module.exports = __webpack_public_path__ + "img/memberCard.04f2a3b1.png";